<template>
  <div class="flex-center-column">
    <img class="title-img" src="@/assets/home/banner_title.png" alt="">
    <!-- 申请入驻按钮-->
    <el-button @click="goApply()" class="apple-btn" type="primary" round>申请入驻</el-button>
  </div>
</template>

<script>
export default {
  name: "home-title",
  methods: {
    goApply() {
      this.$router.push('/apply/select')
    }
  }
}
</script>

<style lang="scss" scoped>
.title-img {
  width: 640px;
  height: 147px;
  margin-top: 242px;
  margin-bottom: 80px;
  object-fit: contain;
}

.apple-btn {
  padding-left: 64px;
  padding-right: 64px;
}
</style>